/** InsCoder 2026-09-18 B + HP 26 story carousel modal: carousel + modal + add to cart **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hp26-sc';

  function initSection(root) {
    if (!root || root.dataset.hp26Ready === 'true') return;
    root.dataset.hp26Ready = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hp26-sc__slide'));
    var sliderEl = root.querySelector('[data-hp26-slider]');
    var prevBtn = root.querySelector('[data-hp26-prev]');
    var nextBtn = root.querySelector('[data-hp26-next]');
    var modals = Array.prototype.slice.call(root.querySelectorAll('[data-hp26-modal]'));
    var count = slides.length;
    var activeIndex = 0;
    var swiper = null;

    if (!count) return;

    /** InsCoder WANG.J 2026-09-22 B + Smooth desktop story navigation **/
    var track = root.querySelector('.hp26-sc__track');
    var desktopAnimations = [];
    var exitSlides = [];

    function clearDesktopMotion() {
      desktopAnimations.forEach(function (animation) { animation.cancel(); });
      desktopAnimations = [];
      exitSlides.forEach(function (slide) { slide.remove(); });
      exitSlides = [];
      track.classList.remove('is-shifting');
    }

    function moveDesktop(direction) {
      if (desktopAnimations.length || count < 2) return;
      if (!slides[0].animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setActiveSlide(activeIndex + direction);
        return;
      }

      var trackRect = track.getBoundingClientRect();
      if (!trackRect.width) {
        setActiveSlide(activeIndex + direction);
        return;
      }
      var before = slides.map(function (slide) {
        return {
          state: slide.dataset.hp26State,
          rect: slide.getBoundingClientRect()
        };
      });
      // Keep only the departing edge as a non-interactive visual copy.
      var edge = direction > 0 ? 'prev' : 'next';
      before.forEach(function (item, i) {
        if (item.state !== edge || i === (activeIndex + direction + count) % count) return;
        var copy = slides[i].cloneNode(true);
        copy.classList.add('hp26-sc__slide--exit');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        copy.querySelectorAll('button, a, [tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        copy.style.setProperty('--hp26-exit-x', (item.rect.left - trackRect.left) + 'px');
        copy.style.setProperty('--hp26-exit-y', (item.rect.top - trackRect.top) + 'px');
        copy.style.setProperty('--hp26-exit-width', item.rect.width + 'px');
        exitSlides.push(copy);
      });

      setActiveSlide(activeIndex + direction);
      track.classList.add('is-shifting');
      var timing = { duration: 700, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
      slides.forEach(function (slide, i) {
        if (slide.dataset.hp26State === 'hidden') return;
        var old = before[i];
        var rect = slide.getBoundingClientRect();
        // A wrapping edge enters from outside, never across the centre card.
        var entering = old.state === 'hidden' ||
          (old.state === edge && slide.dataset.hp26State !== 'active');
        var dx = entering ? direction * (rect.width + 16) : old.rect.left - rect.left;
        var dy = entering ? 0 : old.rect.top - rect.top;
        var sx = entering ? 1 : old.rect.width / rect.width;
        var sy = entering ? 1 : old.rect.height / rect.height;
        desktopAnimations.push(slide.animate([
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')', opacity: entering ? 0 : 1 },
          { transform: 'translate(0, 0) scale(1, 1)', opacity: 1 }
        ], timing));
        var card = slide.querySelector('.hp26-sc__card');
        desktopAnimations.push(card.animate([
          { opacity: old.state === 'active' ? 1 : 0.35 },
          { opacity: slide.dataset.hp26State === 'active' ? 1 : 0.35 }
        ], timing));
      });
      exitSlides.forEach(function (copy) {
        track.appendChild(copy);
        desktopAnimations.push(copy.animate([
          { transform: 'translateX(0)', opacity: 1 },
          { transform: 'translateX(' + (-direction * (copy.getBoundingClientRect().width + 16)) + 'px)', opacity: 0 }
        ], timing));
      });
      Promise.all(desktopAnimations.map(function (animation) { return animation.finished; }))
        .then(clearDesktopMotion, function () {});
    }
    /** InsCoder WANG.J 2026-09-22 E + Smooth desktop story navigation **/

    /* ---------- Main story carousel (desktop custom / mobile Swiper) ---------- */
    function setActiveSlide(index) {
      activeIndex = ((index % count) + count) % count;
      slides.forEach(function (slide, i) {
        var state = 'hidden';
        if (i === activeIndex) {
          state = 'active';
        } else if (count > 1 && i === ((activeIndex - 1 + count) % count)) {
          state = 'prev';
        } else if (count > 1 && i === ((activeIndex + 1) % count)) {
          state = 'next';
        }
        slide.dataset.hp26State = state;
        slide.style.order = state === 'prev' ? '0' : state === 'active' ? '1' : state === 'next' ? '2' : '3';
      });
    }

    function destroySwiper() {
      if (swiper) {
        activeIndex = swiper.realIndex;
        swiper.destroy(true, true);
        swiper = null;
      }
    }

    function initSwiper() {
      if (swiper || !window.Swiper) return;
      swiper = new window.Swiper(sliderEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 8,
        loop: count > 1,
        initialSlide: activeIndex
      });
    }

    function applyMode() {
      clearDesktopMotion();
      if (window.matchMedia('(min-width: 990px)').matches) {
        destroySwiper();
        setActiveSlide(activeIndex);
      } else {
        initSwiper();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (swiper) swiper.slidePrev();
        else moveDesktop(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (swiper) swiper.slideNext();
        else moveDesktop(1);
      });
    }

    window.addEventListener('resize', applyMode);
    /** InsCoder WANG.J 2026-09-22 B + Release desktop motion when the editor unloads this section **/
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      clearDesktopMotion();
      window.removeEventListener('resize', applyMode);
    });
    /** InsCoder WANG.J 2026-09-22 E + Release desktop motion when the editor unloads this section **/

    /* ---------- Modal open / close ---------- */
    function openModal(modal) {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    root.querySelectorAll('[data-hp26-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.dataset.hp26OpenModal);
        if (modals[index]) openModal(modals[index]);
      });
    });

    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-hp26-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });

    /* ---------- Media gallery inside each modal ---------- */
    modals.forEach(function (modal) {
      var mediaImgs = Array.prototype.slice.call(modal.querySelectorAll('[data-hp26-media-img]'));
      var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-hp26-thumb]'));
      var mediaPrev = modal.querySelector('[data-hp26-media-prev]');
      var mediaNext = modal.querySelector('[data-hp26-media-next]');
      var mediaIndex = 0;

      function setMedia(index) {
        var n = mediaImgs.length;
        if (!n) return;
        mediaIndex = ((index % n) + n) % n;
        mediaImgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === mediaIndex);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === mediaIndex);
        });
      }

      if (mediaPrev) {
        mediaPrev.addEventListener('click', function () {
          setMedia(mediaIndex - 1);
        });
      }
      if (mediaNext) {
        mediaNext.addEventListener('click', function () {
          setMedia(mediaIndex + 1);
        });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setMedia(Number(thumb.dataset.hp26Thumb));
        });
      });

      /* ---------- Swipe the gallery (mobile) ---------- */
      /* Figma mobile shows no arrows, only the dot indicator (18345:29291), so the gallery
         has to be swiped. Threshold + axis check keep the modal's own vertical scrolling
         working: a mostly vertical drag is ignored, and nothing is preventDefault-ed. */
      var mediaEl = modal.querySelector('[data-hp26-media]');
      if (mediaEl) {
        var swipeX = 0;
        var swipeY = 0;

        mediaEl.addEventListener('touchstart', function (e) {
          swipeX = e.touches[0].clientX;
          swipeY = e.touches[0].clientY;
        }, { passive: true });

        mediaEl.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - swipeX;
          var dy = e.changedTouches[0].clientY - swipeY;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          setMedia(mediaIndex + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });

    /* ---------- Show more / show less (mobile only) ---------- */
    /* Desktop renders the full description inside a scrolling column instead (Figma
       18562:30129), the button is hidden by CSS there, and the collapsed rules all live
       inside `@media (max-width: 989px)`, so the state is irrelevant above 990px. */
    modals.forEach(function (modal) {
      var panel = modal.querySelector('.hp26-sc__modal-panel');
      var toggle = modal.querySelector('[data-hp26-toggle]');
      var desc = modal.querySelector('[data-hp26-desc]');
      if (!panel || !toggle || !desc) return;

      /* The collapsed layout (352px card + truncation + hidden setup) is only correct when
         a button exists to expand it, so it is opted into from here. Without the button the
         card keeps growing normally and nothing is clipped. */
      panel.classList.add('is-collapsible');

      var more = modal.querySelector('[data-hp26-toggle-more]');
      var less = modal.querySelector('[data-hp26-toggle-less]');

      toggle.addEventListener('click', function () {
        var expanded = !panel.classList.contains('is-expanded');
        panel.classList.toggle('is-expanded', expanded);
        if (more) more.hidden = expanded;
        if (less) less.hidden = !expanded;
      });
    });

    /* ---------- Add to cart ---------- */
    function addToCart(button) {
      var raw = button.dataset.variantIds;
      if (!raw || button.classList.contains('is-loading')) return;

      var ids = raw.split(',').map(function (s) { return Number(s); }).filter(function (n) { return n > 0; });
      if (!ids.length) return;

      button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add product to cart');
          return response.json();
        })
        .then(function () {
          if (typeof theme !== 'undefined' && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
            theme.Cart.prototype._onProductAdded();
          }
        })
        .catch(function (error) {
          console.error('[hp26-sc] add to cart failed', error);
        })
        .finally(function () {
          button.classList.remove('is-loading');
        });
    }

    modals.forEach(function (modal) {
      var atcBtn = modal.querySelector('[data-hp26-atc]');
      if (atcBtn) {
        atcBtn.addEventListener('click', function () {
          addToCart(atcBtn);
        });
      }
    });

    applyMode();
  }

  /* ---------- Global ESC to close any open story modal ---------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.hp26-sc__modal.is-open').forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    });
  });

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.classList && target.classList.contains('hp26-sc')
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-18 E + HP 26 story carousel modal: carousel + modal + add to cart **/
